import { MentionComponent } from './MentionComponent';
import {
  DecoratorNode,
  NodeKey,
  SerializedLexicalNode,
  Spread,
  $applyNodeReplacement,
} from 'lexical';
import React from 'react';

export type SerializedMentionNode = Spread<
  {
    mentionName: string;
  },
  SerializedLexicalNode
>;

export function $createMentionNode(mentionName: string): MentionNode {
  const mentionNode = new MentionNode(mentionName);
  return $applyNodeReplacement(mentionNode);
}

export class MentionNode extends DecoratorNode<React.JSX.Element> {
  __mention: string;

  static getType(): string {
    return 'mention';
  }

  static clone(node: MentionNode): MentionNode {
    return new MentionNode(node.__mention, node.__key);
  }

  constructor(mentionName: string, key?: NodeKey) {
    super(key);
    this.__mention = mentionName;
  }

  exportJSON(): SerializedMentionNode {
    return {
      mentionName: this.__mention,
      type: 'mention',
      version: 1,
    };
  }

  static importJSON(serializedNode: SerializedMentionNode): MentionNode {
    const { mentionName } = serializedNode;
    const node = $createMentionNode(mentionName);
    return node;
  }

  createDOM(): HTMLElement {
    return document.createElement('span');
  }

  updateDOM(): false {
    return false;
  }

  decorate(): React.JSX.Element {
    return (
      <MentionComponent mentionName={this.__mention} nodeKey={this.getKey()} />
    );
  }

  getMentionName(): string {
    return this.__mention;
  }

  setMentionName(mentionName: string): void {
    const writable = this.getWritable();
    writable.__mention = mentionName;
  }
}
